import { useTranslations } from 'next-intl';
import { type FC } from 'react';

import { Button } from '@/components/common/button/Button';
import { Flex } from '@/components/common/Flex';
import { Text } from '@/components/common/Text';

import styles from './SuccessStep.module.scss';

export type SuccessStepProps = {
  goNext: () => unknown;
};

export const SuccessStep: FC<SuccessStepProps> = (props) => {
  const { goNext } = props;

  const t = useTranslations('pages.account.login.form.setup2FaBlock.steps.success');

  return (
    <Flex className={styles.root} direction="column">
      <Flex direction="column" gap={4}>
        <Text className={styles.title} whiteSpace="preWrap">
          {t('title')}
        </Text>

        <Text type="regular18">{t('subtitle')}</Text>
      </Flex>

      <Flex className={styles.formContainer} direction="column">
        <Button onClick={goNext}>{t('buttons.goNext')}</Button>
      </Flex>
    </Flex>
  );
};
